import useSWR from "swr";

import { useManageApiHeaders } from "@is/hooks/useManageApiHeaders";
import { api, createStoreLanguageUrl } from "@is/services/api";

type StoreLanguageResponse = {
  text: string;
};

export const useStoreLanguage = (shouldFetchLanguage = true) => {
  const { setApiHeaders, storeId } = useManageApiHeaders();

  setApiHeaders();

  const url = createStoreLanguageUrl(storeId);

  const { data, error, isLoading } = useSWR(
    shouldFetchLanguage && storeId && url,
    api.get
  );

  const language = (data as StoreLanguageResponse)?.text;
  const storeLanguageCode = language?.split("-")[0];

  return {
    storeLanguageCode,
    isLoading,
    error,
  };
};
